import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
import { FaUserEdit } from "react-icons/fa";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import EditLevelsModal from "../../Components/Modals/EditLevelsModal.js";
import { useDeleteServiceMutation } from "../../Data/services/serviceApi.js";
import EditPackageModal from "../../Components/Modals/EditPackageModal.js";
import { useGetAllGameTeamsQuery } from "../../Data/services/gameApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const GameTeamsManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const dummyData = [
    {
      id: 99,
      game_id: 78,
      name: "",
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 98,
      game_id: 78,
      name: "you",
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 360,
      is_banned: false,
    },
    {
      id: 97,
      game_id: 77,
      name: "Second Team",
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 96,
      game_id: 77,
      name: "First Team",
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 95,
      game_id: 76,
      name: "b,h,h",
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 110,
      is_banned: false,
    },
    {
      id: 94,
      game_id: 76,
      name: "hshz ",
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 70,
      is_banned: false,
    },
    {
      id: 93,
      game_id: 75,
      name: "nsns",
      createdAt: "2025-04-21T13:13:34.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 92,
      game_id: 75,
      name: "nsns",
      createdAt: "2025-04-21T13:13:34.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 10,
      is_banned: false,
    },
    {
      id: 91,
      game_id: 74,
      name: "n,n,",
      createdAt: "2025-04-21T12:51:41.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 90,
      game_id: 74,
      name: "n ,",
      createdAt: "2025-04-21T12:51:41.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 89,
      game_id: 73,
      name: "",
      createdAt: "2025-04-21T10:34:31.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 88,
      game_id: 73,
      name: "First Game",
      createdAt: "2025-04-21T10:34:31.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 10,
      is_banned: false,
    },
    {
      id: 87,
      game_id: 72,
      name: "Team 2",
      createdAt: "2025-04-21T09:21:09.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 86,
      game_id: 72,
      name: "Team 1",
      createdAt: "2025-04-21T09:21:09.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 85,
      game_id: 71,
      name: "",
      createdAt: "2025-04-21T09:15:18.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 84,
      game_id: 71,
      name: "First Game",
      createdAt: "2025-04-21T09:15:18.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 83,
      game_id: 70,
      name: "san",
      createdAt: "2025-04-21T06:51:11.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 82,
      game_id: 70,
      name: "ban",
      createdAt: "2025-04-21T06:51:11.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 81,
      game_id: 69,
      name: "pat",
      createdAt: "2025-04-18T14:38:53.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
    {
      id: 80,
      game_id: 69,
      name: "mat",
      createdAt: "2025-04-18T14:38:53.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      score: 0,
      is_banned: false,
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllGameTeamsQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Team Name",
      sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "score",
      text: "Score",
      sort: true,
      headerStyle: {
        // width: "100px",
      },
    },
    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "200px",
    //   },
    //   formatter: (cellContent, row) => {
    //     // console.log(row)
    //     if (row.slug || row.id) {
    //       return (
    //         <div className="d-flex justify-content-center align-items-center ">
    //           <div
    //             className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 text-white`}
    //             role="button"
    //             onClick={() => {
    //               setEditedData(row);
    //               handleEditModalOpen(true);
    //             }}
    //           >
    //             <span
    //               className={`align-items-center d-flex justify-content-center pe-1  `}
    //             >
    //               <FaUserEdit />
    //             </span>
    //             <span>Edit</span>
    //           </div>

    //           {/* <div
    //             className="d-flex justify-content-center align-items-center bg-danger text-white rounded-3 p-2 mx-2 "
    //             role="button"
    //             onClick={() => {
    //               setEditedData(row);
    //               handleDeleteModalOpen();
    //             }}
    //           >
    //             <span className={`d-flex align-items-center pe-1`}>
    //               <MdDeleteForever />
    //             </span>
    //             <span>Delete</span>
    //           </div> */}
    //         </div>
    //       );
    //     }
    //   },
    // },
  ];

  return (
    <div className={styles.MainContainer}>
      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditPackageModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            // refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Game Teams Management"} classes="text-black" />
        </div>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add Package"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                // refetch={refetch} // todo
                refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default GameTeamsManagementScreen;
